export class ExchangeError extends Error {
    constructor(failure) {
        super(`Auth exchange failed: ${failure.kind}`);
        this.failure = failure;
        this.name = 'ExchangeError';
    }
}
